export default __webpack_public_path__ + "static/media/sd-india-flag.4f1072b9.svg";